$(document).ready(function() {
   $(".specific-faq-section > a").first().addClass("active");
  $(".specific-faq-section > a").first().siblings(".content").slideDown(200);
  $('.qa-pro-info').first().siblings('.content').slideUp();
  $('.qa-pro-info').first().removeClass('active');
  $(".set > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".content")
        .slideUp(200);
      
    } else {
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
        .siblings(".content")
        .slideDown(200);
    }
  });
});